export default {
    namespaced: true,
    state: {
		managerGeneralOrder: 'Return (% - pa over 1y)',
		maximumDate: '',
		minimumDate: '',
		sliderDates: [],
        ManagerComparison: false,
        dropdownSelected: false,
        expandSelectedData: false,
        fullScreen: true,
        loadState: 'loading',
        managerDeleted: false,
        pageState: 'loading',
        pageView: 'home',
        showModal: false,
        showSelectedData: false,
        showTable: false,
        testAdded: false,
    },
    mutations: {
        updateDates (state, data) {
            state.minimumDate = data[0];
            state.maximumDate = data[1];
		},
		updateSliderDates(state, sliderDates) {
            state.sliderDates = sliderDates;
		},
        updateExpandSelectedData (state, updateData) {
            state.expandSelectedData = updateData;
        },
        toggleFullscreen (state) {
            state.fullScreen = !state.fullScreen;
        },
        setNotFullscreen (state) {
            state.fullScreen = false;
        },
        updateLoadState (state, status) {
            state.loadState = status;
        },
        updatePageState (state, status) {
            state.pageState = status;
        },
        toggleTests (state) {
            state.pageView = state.pageView === 'tests' ? 'home' : 'tests';
        },
        updateShowSelectedData (state, updateData) {
            state.showSelectedData = updateData;
        },
        updateShowTable (state, updateData) {
            state.showTable = updateData;
        },
        updateManagerGeneralOrder (state, data) {
            state.managerGeneralOrder = data;
        },
        homeView (state) {
            state.ui.pageView = 'home';
            state.ui.ManagerComparison = false;
        },
        toggleModal (state) {
            state.showModal = !state.showModal;
        },
        setShowModal (state, boolean) {
            state.showModal = boolean;
        },
    },
    actions: {

    },
};
